var endpointMap = {
	en: {
		translations: "translation-en.json"
	},
	"en-GB": {
		translations: "translation-en.json"
	},
	"en-US": {
		translations: "translation-en.json"
	},
	es: {
		translations: "translation-es.json"
	},
	"es-ES": {
		translations: "translation-es.json"
	},
	fr: {
		translations: "translation-fr.json"
	},
	"fr-FR": {
		translations: "translation-fr.json"
	},
	und: {
		translations: "translation.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
